import type { Feature, Polygon } from 'geojson';
import { GeoDataUtilities } from '@rogoag/shared-ts';

class HolesMerger {
  merge(firstHole: Feature<Polygon>, secondHole: Feature<Polygon>): { coordinates: number[][]; error?: string } {
    if (!GeoDataUtilities.polygonOverlapsPolygon(firstHole, secondHole).overlaps) {
      return { coordinates: [], error: 'Holes do not intersect, aborting.' };
    }

    const gluedShape = GeoDataUtilities.glueShapes([firstHole, secondHole]);
    const { isValid: isShapeValid } = GeoDataUtilities.isPolygonValid(gluedShape);

    if (!isShapeValid) {
      return { coordinates: [], error: `Merged hole is not valid, aborting.` };
    }

    if (gluedShape.geometry.type === 'MultiPolygon') {
      return { coordinates: gluedShape.geometry.coordinates[0][0] };
    }

    if (gluedShape.geometry.type === 'Polygon') {
      return { coordinates: gluedShape.geometry.coordinates[0] };
    }

    return { coordinates: [], error: `Merged hole has unexpected geometry type: aborting.` };
  }
}

const holesMerger = new HolesMerger();

export default holesMerger;
